// AUTO-CRM-32: the CRM's cast, a subset of the Auto Appy character library
// (auto-appy src/features/Workspace/characters.js). Keys, tints and art are the
// same as there; only the characters the CRM shows are bundled.
// A character is only a look: it never changes what an agent can do or access.
import appy from './assets/characters/appy.webp';
import atlas from './assets/characters/atlas.webp';
import nila from './assets/characters/nila.webp';
import appyFull from './assets/characters/appy-full.webp';
import atlasFull from './assets/characters/atlas-full.webp';
import nilaFull from './assets/characters/nila-full.webp';

// appy: automation steps and "all clear"; atlas: the Insights briefing; nila: Home's "needs you".
export const CHARACTERS = [
  { key: 'appy', label: 'Appy · classic white', tint: '#E3EFF7', image: appy, full: appyFull },
  { key: 'atlas', label: 'Cobalt, tool belt', tint: '#DDE6F6', image: atlas, full: atlasFull },
  { key: 'nila', label: 'Sky blue', tint: '#E1EBF8', image: nila, full: nilaFull },
];

const byKey = Object.fromEntries(CHARACTERS.map((character) => [character.key, character]));

export const characterFor = (key) => (key && byKey[key]) || null;
